var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4V4.3453C10.0003 5.05983 9.61915 5.72008 9.00034 6.07735L8.15467 6.5656C7.53587 6.92286 6.77348 6.92286 6.15467 6.5656L5.85564 6.39295C5.37734 6.11681 4.76575 6.28068 4.48961 6.75897L3.48961 8.49103C3.21347 8.96932 3.37734 9.58091 3.85564 9.85705L4.15467 10.0297C4.77348 10.387 5.15467 11.0472 5.15467 11.7618L5.15467 12.7383C5.15467 13.4528 4.77348 14.113 4.15467 14.4703L3.85564 14.643C3.37734 14.9191 3.21347 15.5307 3.48961 16.009L4.48961 17.741C4.76575 18.2193 5.37734 18.3832 5.85564 18.1071L6.15468 17.9344C6.77348 17.5771 7.53587 17.5771 8.15467 17.9344L9.00034 18.4227C9.61915 18.7799 10.0003 19.4402 10.0003 20.1547V20.5C10.0003 21.0523 10.4481 21.5 11.0003 21.5H13.0003C13.5526 21.5 14.0003 21.0523 14.0003 20.5V20.1547C14.0003 19.4402 14.3815 18.7799 15.0003 18.4226L15.846 17.9344C16.4648 17.5771 17.2272 17.5771 17.846 17.9344L18.1451 18.107C18.6233 18.3832 19.2349 18.2193 19.5111 17.741L20.5111 16.009C20.7872 15.5307 20.6233 14.9191 20.1451 14.6429L19.846 14.4703C19.2272 14.113 18.846 13.4528 18.846 12.7382L18.846 11.7617C18.846 11.0472 19.2272 10.387 19.846 10.0297L20.1451 9.85705C20.6234 9.5809 20.7872 8.96931 20.5111 8.49102L19.5111 6.75897C19.2349 6.28068 18.6234 6.1168 18.1451 6.39295L17.846 6.5656C17.2272 6.92286 16.4648 6.92286 15.846 6.5656L15.0003 6.07735C14.3815 5.72008 14.0003 5.05983 14.0003 4.3453V4C14.0003 3.44772 13.5526 3 13.0003 3H11.0003C10.4481 3 10.0003 3.44772 10.0003 4Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3409febca0ed8c029db78e6550c1aff6.svg";
export { ForwardRef as ReactComponent };